export function processConversation(data) {
 
    const jsonData = JSON.parse(data);

    switch (jsonData.type) {
        case 'NEWCONVERSATION':
            return {type: 'NEWCONVERSATION', data: jsonData.data};
            break;
        case 'NOTIFICATION':
            return {type: 'NOTIFICATION', data: jsonData.data};    

        default:
            return jsonData;
    }
    
  
   
    //NEWCONVERSATION
}  


